import { render, staticRenderFns } from "./BtnReprovar.vue?vue&type=template&id=62545378"
import script from "./BtnReprovar.vue?vue&type=script&lang=js"
export * from "./BtnReprovar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports